

export function isMobileDevice() {
    const regex = /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
    const minWidth = 768;
    return regex.test(navigator.userAgent)
        || (window.innerWidth < minWidth || screen.width < minWidth);
};
export function htmlDecode(value) {
    var decode = document.createElement('textarea');
    decode.innerHTML = value;
    var result = decode.value;
    decode.remove();
    return result;
};

export function interpolate(str, params) {
    let names = Object.keys(params);
    let vals = Object.values(params);
    return new Function(...names, `return \`${htmlDecode(str)}\`;`)(...vals);
};

export function appendHtml(html, target) {
    var fragment = document.createDocumentFragment();
    var temp = document.createElement('div');
    temp.innerHTML = html;
    while (temp.firstChild) {
        fragment.appendChild(temp.firstChild);
    }
    (target || document.body).appendChild(fragment);
};

export function renderTemplate(tplId, data) {
    var template = document.getElementById(tplId);
    if (!template) {
        return '';
    }

    return interpolate(template.innerHTML, { data });
};

export function triggerEvent(element, eventName, options) {
    var eventClass = Event;
    switch (eventName) {
        case "focus":
        case "blur":
        case "focusin":
        case "focusout": eventClass = FocusEvent; break;
        case "keydown":
        case "keypress":
        case "keyup": eventClass = KeyboardEvent; break;
        case "click":
        case "dblclick":
        case "mouseover":
        case "mouseout":
        case "mouseenter":
        case "mouseleave":
        case "mouseup":
        case "mousedown": eventlClass = MouseEvent; break;
        case "drag":
        case "dragend":
        case "dragenter":
        case "dragleave":
        case "dragover":
        case "dragstart":
        case "drop": eventClass = DragEvent; break;
        case "touchstart":
        case "touchend":
        case "touchmove":
        case "touchcancel": eventClass = TouchEvent; break;
        case "transitionstart":
        case "transitionend":
        case "transitionrun":
        case "transitioncancel": eventClass = TransitionEvent; break;
        case "pointerover":
        case "pointerenter":
        case "pointerdown":
        case "pointermove":
        case "pointerup":
        case "pointercancel":
        case "pointerout":
        case "pointerleave":
        case "gotpointercapture":
        case "lostpointercapture": eventClass = PointerEvent; break;
        case "beforeunload": eventClass = BeforeUnloadEvent; break;
        case "cut":
        case "copy":
        case "paste": eventClass = ClipboardEvent; break;
        case "devicemotion": eventClass = DeviceMotionEvent; break;
        case "deviceorientation": eventClass = DeviceOrientationEvent; break;
        case "fetch": eventClass = FetchEvent; break;
        case "gamepadconnected":
        case "gamepaddisconnected": eventClass = GamepadEvent; break;
        case "hashchange": eventClass = HashChangeEvent; break;
        case "addtrack":
        case "removetrack": eventClass = TrackEvent; break;
        case "modalopen":
        case "modalclose": eventClass = UIEvent; break;
        default: eventClass = Event; break;
    }

    const eventOptions = Object.assign({}, {
        bubbles: true,
        cancelable: false
    }, options);
    const event = new eventClass(eventName, eventOptions);
    element.dispatchEvent(event);
}

export function getAttribute(element, attributeName) {
    if (element[attributeName] != undefined) {
        return element[attributeName];
    }
    return element.getAttribute(attributeName);
}

export function hasClass(element, className) {
    if (element) {
        return element.classList.contains(className);
    }
    return false;
}

export function copyToClipboard(text) {
    if (navigator.clipboard) {
        try {
            navigator.clipboard.writeText(text).then(
                () => {
                    // succeed
                },
                (ex) => {
                    console.error('Copy to clipboard failed: ', ex);
                }
            );
        }
        catch (ex) {
            console.error('Copy to clipboard failed: ', ex);
        }
    }
    else {
        var area = document.createElement("textarea");
        area.value = text;

        // Avoid scrolling to bottom
        area.style.top = "0";
        area.style.left = "0";
        area.style.position = "fixed";

        document.body.appendChild(area);
        area.focus();
        area.select();

        try {
            var successful = document.execCommand('copy');
            if (successful) {

            }
            else {
                console.error('Copy to clipboard failed without error');
            }
        }
        catch (ex) {
            console.error('Copy to clipboard failed: ', ex);
        }

        document.body.removeChild(area);
    }
}
